<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-button
					v-if="$hasPermission('reasonState.add')"
					class="float-right"
					@click="newDestination"
					>Nueva razón de cambio de status</b-button
				>
				<h2>Razón cambio de status</h2>
				<hr class="mb-3" />

				<VueTreeList
					@drop-before="dropBefore"
					@drop-after="test('drop-after')"
					@add-node="test('add-node')"
					@drop="drop"
					v-if="model && $hasPermission('reasonState.show')"
					:model="model"
				>
					<template v-slot:leafNameDisplay="slotProps">
						<span :class="getStyle(slotProps.model)">
							{{ slotProps.model.id }} -
							<span v-if="slotProps.model.parent.id === 0">
								<b-badge
									:variant="getToStatus(slotProps.model).class"
								>
									{{ getToStatus(slotProps.model).text }}
								</b-badge>
							</span>
							{{ slotProps.model.label }}
						</span>
						<span
							class="mx-2"
							v-if="slotProps.model.status === 'inactive'"
						>
							<b-badge>
								Desabilitado
							</b-badge>
						</span>
						<span class="ml-4">
							<b-button
								v-if="slotProps.model.change"
								@click="confirmDrop(slotProps.model)"
								type="button"
								size="sm"
								:disabled="!$hasPermission('reasonState.edit')"
								pill
								class="mr-1"
								variant="primary"
							>
								<md-icon icon="save" />
							</b-button>
							<b-button
								@click="userView(slotProps.model, $event)"
								type="button"
								size="sm"
								pill
								class="mr-1"
								variant="light"
							>
								<md-icon icon="edit" />
							</b-button>

							<b-button
								@click="userDelete(slotProps.model)"
								v-if="$hasPermission('reasonState.delete')"
								type="button"
								size="sm"
								pill
								class="mr-1"
								variant="danger"
							>
								<md-icon icon="delete" />
							</b-button>
						</span>
					</template>
				</VueTreeList>
			</div>
			<hr />
		</div>
		<b-modal
			hide-footer
			id="modal-reasonStates-view"
			size="lg"
			:title="
				modalInfo.modelId > 0
					? 'Edición de razon de estado'
					: 'Nueva razon de estado'
			"
		>
			<Single
				:unableEdit.sync="unableEdit"
				:model-id="modalInfo.modelId"
				@modal-id="modalInfo.modelId = $event"
				modal-id="modal-reasonStates-view"
			/>
		</b-modal>
		<b-overlay no-wrap :show="loading" />
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
import Single from "./Single.vue";
import api from "../../../api.js";
import { VueTreeList, Tree } from "vue-tree-list";
export default {
	components: { MainLayout, Single, VueTreeList },
	data() {
		return {
			modalInfo: {
				modelId: -1,
				title: "Razones de Estado"
			},
			loading: false,
			unableEdit: false,
			model: null
		};
	},
	computed: {
		reasonStateOpts() {
			return this.$root.auxVars.reasonStateOpts;
		}
	},
	watch: {
		reasonStateOpts(v) {
			if (v) {
				this.initModel();
			}
		}
	},

	methods: {
		dropBefore(item) {
			if (item.node.parent?.id !== item.node.originalParentId) {
				item.node.change = true;
			} else {
				item.node.change = false;
			}
		},
		test() {},
		drop(item) {
			if (item.node.parent?.id !== item.node.originalParentId) {
				item.node.change = true;
			} else {
				item.node.change = false;
			}
		},
		getStyle(item) {
			if (item.change) return "change-text";
			if (item.status === "inactive") return "disabled-text";
		},
		confirmDrop(item) {
			const { id, parent } = item;
			const { label, toStatus, status } = item;
			const params = {
				id: id,
				data: {
					label,
					toStatus,
					status,
					parentId: parent.id > 0 ? { id: parent.id } : null
				}
			};
			this.updateReason(params);
		},
		updateReason({ id, data }) {
			this.loading = true;
			let rParams = {
				url: `/reasonStates/${id}`,
				method: "PUT",
				data: data
			};

			api(this)
				.request(rParams)
				.then(() => {
					this.$root.showAlert("OK!");
					this.$root.auxVars.loadResourcesOpts({
						vm: this,
						resourceNames: ["reasonStates"],
						forceRefresh: true
					});
					this.$root.auxVars.loadResourcesOpts({
						vm: this,
						resourceNames: ["reasonStatesActive"],
						forceRefresh: true
					});
				})
				.catch(error => {
					if (error.response && error.response.status == 422) {
						let message = "Error!";
						Object.keys(error.response.data).forEach(function(key) {
							message = error.response.data[key][0];
						});
						this.$root.showAlert(message, { variant: "danger" });
					} else {
						this.$root.handleRequestError(error);
					}
					this.loading = false;
				})
				.then(() => {
					this.loading = false;
				});
		},
		initModel() {
			this.model = null;
			this.model = new Tree(this.map(this.reasonStateOpts));
		},
		map(arr) {
			return arr ? arr.map(this.fix) : null;
		},

		fix(item) {
			item.change = false;
			item.addTreeNodeDisabled = true;
			item.addLeafNodeDisabled = true;
			item.editNodeDisabled = true;
			item.delNodeDisabled = true;
			if (item.children)
				return {
					...item,
					originalParentId: item.parentId?.id,
					children: this.map(item.children)
				};
			delete item.children;
			return item;
		},

		getStatus(status) {
			return this.status.find(({ value }) => value === status).text;
		},
		getToStatus(item) {
			const status = item.toStatus;
			return (
				this.$root.auxVars.transportServiceStatusOpts.find(
					({ value }) => value === status
				) || {}
			);
		},
		userView(item, event) {
			this.unableEdit = !this.$hasPermission('reasonState.edit')
			this.modalInfo.modelId = item.id;
			this.modalInfo.title = "Datos de razon de estado";
			this.$root.$emit(
				"bv::show::modal",
				"modal-reasonStates-view",
				event.target
			);
		},
		itemsFilter(items) {
			return items;
		},
		newDestination(event) {
			this.unableEdit = false
			this.modalInfo.modelId = -1;
			this.modalInfo.title = "Nueva razon de estado";
			this.$root.$emit(
				"bv::show::modal",
				"modal-reasonStates-view",
				event.target
			);
		},

		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/reasonStates/${item.id}`)
						.then(response => {
							if (response.data.error) {
								this.$root.showAlert(response.data.message, {
									variant: "warning"
								});
								close();
								return false;
							}

							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["reasonStates"],
								forceRefresh: true
							});
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["reasonStatesActive"],
								forceRefresh: true
							});
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["reasonStates"]
		});
		this.initModel();
	}
};
</script>
<style scoped>
.disabled-text {
	color: rgb(206, 202, 202);
}
.change-text {
	font-weight: bold;
}
</style>
